import { lazy } from 'react'
import { type RouteObject } from 'react-router-dom'

const DaftarSesiPage = lazy(() => import('./pages/daftar-sesi'))
const BagiAreaOpnamePage = lazy(() => import('./pages/bagi-area-opname'))
const JadwalOpnamePage = lazy(() => import('./pages/jadwal-opname'))
const DetailSesiPage = lazy(() => import('./pages/detail-sesi'))
const OpnameOperatorPage = lazy(() => import('./pages/opname-operator'))
const SelisihPage = lazy(() => import('./pages/selisih'))
const LaporanOpnamePage = lazy(() => import('./pages/laporan-opname'))

/**
 * Cluster C13 Stock Opname — OPN-01 (daftar-sesi), OPN-01 Bagi Area (daftar-sesi/mulai), OPN-01A (daftar-sesi/jadwal),
 * OPN-01B (daftar-sesi/:id, daftar-sesi/:id/rak/:taskId), OPN-03 (opname-operator), OPN-04 / 04A (selisih, selisih/:id),
 * OPN-06 (laporan).
 */
const stockOpnameRoutes: RouteObject[] = [
  {
    path: 'stock-opname',
    children: [
      {
        path: 'daftar-sesi',
        children: [
          { index: true, element: <DaftarSesiPage /> },
          { path: 'mulai', element: <BagiAreaOpnamePage /> },
          { path: 'jadwal', element: <JadwalOpnamePage /> },
          { path: ':id', element: <DetailSesiPage /> },
          { path: ':id/rak/:taskId', element: <DetailSesiPage /> }
        ]
      },
      { path: 'opname-operator', element: <OpnameOperatorPage /> },
      {
        path: 'selisih',
        children: [
          { index: true, element: <SelisihPage /> },
          { path: ':id', element: <SelisihPage /> }
        ]
      },
      { path: 'laporan', element: <LaporanOpnamePage /> }
    ]
  }
]

export default stockOpnameRoutes
